import { render, staticRenderFns } from "./RenewAuthTable.vue?vue&type=template&id=5c95a9af&scoped=true"
import script from "./RenewAuthTable.vue?vue&type=script&lang=js"
export * from "./RenewAuthTable.vue?vue&type=script&lang=js"
import style0 from "./RenewAuthTable.vue?vue&type=style&index=0&id=5c95a9af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c95a9af",
  null
  
)

export default component.exports